import { requestServer } from '@repo/ui/src/utils/requestServer';
import { serverRuntimeConfig } from '@utils/serverRuntimeConfig';

export const query = /* GraphQL */ `
  query SearchAuthors(
    $query: String
    $pageSize: Int
    $page: Int
    $sort: SearchableAuthorSortInput
    $filter: SearchableAuthorFilterInput
  ) {
    searchAuthors(query: $query, pageSize: $pageSize, page: $page, sort: $sort, filter: $filter) {
      hits {
        _meta {
          deliveryId
          deliveryKey
        }
        id
        name
        title
        avatar {
          name
          endpoint
        }
        city
        stateProvince
        country
      }
      page
      nbHits
      nbPages
    }
  }
`;

interface Props {
  filters: string;
  page?: string;
  pageSize?: string;
  sort?: string;
  lang: string;
  deliveryKey?: string;
  preview?: boolean;
}

const searchAuthorsFn = async ({
  filters,
  page = '0',
  pageSize = '10',
  sort,
  lang,
  deliveryKey,
  preview,
}: Props) => {
  try {
    const pageNumber = isNaN(Number(page)) ? 0 : Number(page);
    const pageSizeNumber = isNaN(Number(pageSize)) ? 10 : Number(pageSize);

    const data = await requestServer(
      {
        document: query,
        variables: {
          filter: filters ? JSON.parse(filters) : null,
          pageSize: pageSizeNumber,
          page: pageNumber,
          sort: sort ? JSON.parse(sort) : null,
        },
        requestHeaders: {
          'Accept-Language': lang || 'en-US',
        },
      },
      {
        tags: deliveryKey ? [`page-${deliveryKey}`] : undefined,
        revalidate: preview ? 0 : serverRuntimeConfig.revalidate.pageTime,
      },
    );

    if (data?.errors) {
      throw new Error(data.errors.map((x: any) => `${x.errorType} - ${x.message}`).join(','));
    }

    if (data?.searchAuthors) {
      const result = data.searchAuthors;
      return { hits: result.hits, nbHits: result.nbHits, nbPages: result.nbPages };
    }
    return { hits: [], nbHits: 0, nbPages: 0 };
  } catch (error) {
    throw new Error(JSON.stringify(error));
  }
};

export default searchAuthorsFn;
